import React from "react";

// Local
import { countryRegionColor } from "../../styled/styled";

const CountryLine = ({
  data,
  scale,
  recordMatrix,
  currentProjection,
  tooltip
}) => {
  // const { mutualCountries } = tooltip;
  const {
    geoXScale,
    geoYScale,
    tsneXScale,
    tsneYScale,
    lineThicknessScale,
    lineOpacityScale
  } = scale;
  const hovCountry = data.find(el => el.country === tooltip.country);
  const mutualCountries = recordMatrix.filter(
    el => el.country1 === tooltip.country
  );

  return (
    <g classname="line">
      {mutualCountries.map(ctry => {
        let mutCountry = data.find(el => el.country === ctry.country2);
        if (typeof mutCountry === "undefined") {
          mutCountry = hovCountry;
        }

        return (
          <line
            x1={
              currentProjection === "geo"
                ? geoXScale(hovCountry.x_geo)
                : tsneXScale(hovCountry.x_tsne)
            }
            y1={
              currentProjection === "geo"
                ? geoYScale(hovCountry.y_geo)
                : tsneYScale(hovCountry.y_tsne)
            }
            x2={
              currentProjection === "geo"
                ? geoXScale(mutCountry.x_geo)
                : tsneXScale(mutCountry.x_tsne)
            }
            y2={
              currentProjection === "geo"
                ? geoYScale(mutCountry.y_geo)
                : tsneYScale(mutCountry.y_tsne)
            }
            stroke={countryRegionColor(ctry.region2)}
            strokeWidth={lineThicknessScale(ctry.orgCount)}
            opacity={lineOpacityScale(ctry.orgCount)}
            // opacity={lineOpacityScale(ctry.orgCount)}
          />
        );
      })}
    </g>
  );
};

export default CountryLine;
